<template>
      <div  >
        <img style="width:100%" :src="$store.state.info.adPic" alt="">
        <div class='mask' v-if="types" @click="types=false">
            <div class="conatiner" @click="types=false">
                <p style="font-size:0.5rem;margin-bottom:0;">长按保存图片</p>
                <p style="font-size:0.5rem;margin-bottom:0;">分享好友</p>
                <div>
                    <span @click="types=false" class='btn'>我知道了</span>
                </div>
            </div>
        </div>
      </div>
</template>
<script>
import { getSign } from '@/api/login'
import wx from 'weixin-js-sdk'
export default {
    data(){
        return{
            types:true
        }
    },
    mounted(){
        this.open()
    },
    methods:{
        toShare(){
      wx.ready( ()=> {      //需在用户可能点击分享按钮前就先调用
        wx.updateTimelineShareData({ 
          title: '分享成功', // 分享标题
          link: location.origin+location.pathname, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: location.origin+'/static/img/logo1.png', // 分享图标
          success: function () {
            // alert(1)
            console.log('successVue')
            // 设置成功
          }
        })
      }); 
    },
    toQuan(){
      wx.ready( ()=> {      //需在用户可能点击分享按钮前就先调用
        wx.updateTimelineShareData({  
          title: '分享成功', // 分享标题
          link: location.origin+location.pathname, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: location.origin+'/static/img/logo1.png', // 分享图标
          success: function () {
            // alert(1)
            console.log('successVue')
            // 设置成功
          }
        })
      }); 
    },
   toQQ(){
      wx.ready( ()=> {      //需在用户可能点击分享按钮前就先调用
        wx.onMenuShareAppMessage({ 
          title:'麦德通',
          desc: '友福同享丨帮你在麦德通申请了150元代金券和免费英国VAT，速领！', // 分享标题
          link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://user.ippmaster.com/logo.png',  // 分享图标
          success: function () {
            // alert(1)
            console.log('successVue')
            // 设置成功
          }
        })
      }); 
    },
    open(){
      getSign({url:location.href}).then(res=>{
      this.url=res.data
       wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature:res.data.signature,// 必填，签名
        jsApiList: ['onMenuShareAppMessage','hideMenuItems','hideOptionMenu'] // 必填，需要使用的JS接口列表
      });
      wx.ready(function () {
        wx.hideMenuItems({
          menuList: ["menuItem:share:appMessage",  "menuItem:share:timeline", 'menuItem:share:qq', ]
        })
      })
    })
    },
    }
}
</script>
<style scoped>
.mask{
    position: fixed;
    width:100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    left:0;
    top:0;
}
.conatiner{
    width:100%;
    position: absolute;
    left:50%;
    top: 50%;
    transform: translate(-50%,-50%);
    color: #fff;
}
.btn{
    border-radius: 2rem;
    display: inline-block;
    border: 1px solid #fff;
    font-size: 0.3rem;
    padding: 0.1rem 0.5rem;
    margin-top: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/views/shareImg.vue